module.exports = __webpack_public_path__ + "img/rainbow2.32c216ab.png";